import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.scss";
const H3Font = ({ children, fontWeight = 300, color = "#333", className }) => (_jsx("h3", { style: { color, fontWeight }, className: [className, styles.h3_font].join(" "), children: children }));
export default H3Font;
